import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../../commponents/layout/adminLayout";
import InvoiceBasicInformation from "../../commponents/invoice/detail/InvoiceBasicInformation";
import InvoiceItemList from "../../commponents/invoice/detail/InvoiceItemList";
import InvoicePriceInformation from "../../commponents/invoice/detail/InvoicePriceInformation";
import { getInvoiceById } from "../../api/invoiceApi";
import { showError } from "../../utils/ alert";

interface InvoiceDetailData {
  id: number;
  invoice_no: string;
  recipient_name: string;
  address?: string | null;
  phone?: string | null;
  sales: {
    id: number;
    name: string;
  };
  po_number?: string | null;
  customer_id?: string | null;
  delivery_time: string;
  due_date: string;
  invoice_date: string;
  discount: string;
  ppn: string;
  subtotal: string;
  grand_total: string;
  total_payment_due: string;
  customer_id_ref: number;
  status: string;
  createdAt: string;
  items: {
    description: string;
    qty: number;
    unit: string;
    price: number;
    total: number;
  }[];
}

export default function InvoiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [invoice, setInvoice] = useState<InvoiceDetailData | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        setLoading(true);
        const response = await getInvoiceById(Number(id));
        setInvoice(response.data.data ?? response.data);
      } catch (error) {
        showError(
        "Failed",
        "Failed to Load data."
    );
        showError("Failed to load invoice detail.");
        navigate("/invoice");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchDetail();
  }, [id]);

  if (loading || !invoice) {
    return (
      <AdminLayout>
        <div className="rounded-3xl bg-white p-6 text-center text-gray-400">
          Loading...
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="rounded-3xl bg-white p-6">
          <h2 className="mb-4 text-lg font-semibold">Detail Invoice</h2>

          <InvoiceBasicInformation
            invoice={{
              recipient_name: invoice.recipient_name,
              address: invoice.address,
              phone: invoice.phone,
              invoice_no: invoice.invoice_no,
              invoice_date: invoice.invoice_date,
              sales_name: invoice.sales.name,
              po_number: invoice.po_number,
              customer_id: String(invoice.customer_id_ref),
              total_payment_due: Number(invoice.total_payment_due),
              delivery_time: invoice.delivery_time,
              due_date: invoice.due_date,
              createdAt: invoice.createdAt,
            }}
            onEdit={() => navigate(`/invoice/edit/${invoice.id}`)}
          />
        </div>

        <div className="rounded-3xl bg-white p-6">
          <InvoiceItemList items={invoice.items} />
        </div>

        <div className="rounded-3xl bg-white p-6">
          <InvoicePriceInformation
            subtotal={Number(invoice.subtotal)}
            discount={Number(invoice.discount)}
            ppn={Number(invoice.ppn)}
            grandTotal={Number(invoice.grand_total)}
          />
        </div>

        <div className="rounded-3xl bg-white p-6">
          <h3 className="mb-3 text-sm font-semibold text-gray-700">
            Informasi Pembayaran
          </h3>
          <div className="space-y-1 text-sm text-gray-600">
            <p>
              <span className="inline-block w-32 text-gray-500">Bank</span>
              <span>: BCA</span>
            </p>
            <p>
              <span className="inline-block w-32 text-gray-500">
                No. Rekening
              </span>
              <span>: 1234567890</span>
            </p>
            <p>
              <span className="inline-block w-32 text-gray-500">Atas Nama</span>
              <span>: PT ABC</span>
            </p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
